<template>
  <div class="green-gradient-down d-flex flex-row align-center justify-space-between rounded-lg white--text w-100 mx-md-2 px-md-10">
    <span class="d-flex my-2" :class="$vuetify.breakpoint.lgAndUp ? 'flex-row align-center' : 'flex-column'">
      <h3 class="font-bukhari" :class="$vuetify.breakpoint.lgAndUp ? 'text-h4' : 'text-h5'" style="line-height: 100%">{{ $t('label.hello') }}</h3>
      <span class="text-h5 font-weight-bold yellow--text text--lighten-1" :class="$vuetify.breakpoint.lgAndUp ? 'text-h5 ml-4' : 'text-h6'" style="line-height: 100%">{{ currentUser.full_name }}</span>
    </span>
    <router-link v-if="isSGUser" class="text-decoration-none white--text" :to="{ name: $constants.ROUTE_NAME.APPOINTMENT_MY_APPOINTMENT }">
      <span class="mr-2 d-flex align-center">
        <span class="icon-sizing white d-flex justify-center align-center rounded-circle">
          <CalendarIcon />
        </span>
        <div v-if="currentUser.next_appointment_date" class="ml-2">
          <p class="text-mini mb-lg-1 text-truncate">{{ $t('label.upcomingAppointment') }}</p>
          <p class="text-mini my-0">{{ currentUser.next_appointment_date | shortDate }}</p>
        </div>
      </span>
    </router-link>
    <app-button v-if="isSGUser" :label="$t('label.makeAppointment')" class="secondary--text px-lg-7" :to="{ name: $constants.ROUTE_NAME.APPOINTMENT_MAKE_APPOINTMENT }" />
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'

import CalendarIcon from '@/assets/icons/calendar.svg'

export default {
  components: { CalendarIcon },

  computed: {
    ...mapGetters('auth', ['isSGUser']),
    ...mapState('auth', ['currentUser'])
  }
}
</script>

<style lang="scss" scoped>
.font-bukhari {
  font-family: 'BukhariScript' !important;
}

.icon-sizing {
  width: 40px;
  height: 40px;
}

.half-full-width {
  max-width: 55%;
}

// .appointment-box {
//   @media only screen and (min-width: 640px) {
//     max-width: 55%;
//   }

//   @media only screen and (min-width: 1800px) {
//     max-width: auto;
//   }
// }
</style>
